export default __webpack_public_path__ + "static/media/income_proj_01.897fa3ed.png";